var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButterfly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1797 9.93005C12.2697 10 12.3197 10.13 12.3597 10.27C14.7797 6.25005 15.8997 5.02005 20.1897 2.96005C21.0197 2.58005 22.1197 2.06005 22.6297 2.29005C22.9497 2.43005 23.0297 2.83005 22.6497 3.66005C22.1597 5.34005 22.2197 6.76005 22.2697 8.39005C22.2897 8.82005 22.3097 9.27005 22.3097 9.71005V9.73005C21.3197 12.89 19.8197 12.71 17.1197 12.38C16.5097 12.31 15.7997 12.22 15.0497 12.16C15.6997 12.25 16.2897 12.32 16.8397 12.39C21.2197 12.91 23.0097 15.62 20.8997 19.15C17.1797 25.37 14.7297 18.37 13.2897 15.06C12.9697 14.32 12.6197 13.42 12.2597 12.64",
    fill: "#0C7189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1502 12.62C11.8302 13.41 11.5202 14.21 11.2302 14.96C9.93021 18.35 7.78021 25.44 3.82021 19.4C1.55021 15.94 3.22021 13.14 7.59021 12.44C8.13021 12.35 8.71021 12.26 9.36021 12.13C8.60021 12.22 7.92021 12.33 7.30021 12.44C4.61021 12.89 3.12021 13.13 2.00021 10.02V9.99997C1.98021 9.56997 1.98021 9.11997 1.98021 8.67997C1.96021 7.05997 1.96021 5.62997 1.38021 3.96997C0.98021 3.13997 1.04021 2.73997 1.34021 2.59997C1.83021 2.36997 2.95021 2.81997 3.79021 3.17997C8.17021 5.03997 9.29021 6.34997 11.8902 10.27C11.9302 10.07 12.0202 9.94997 12.1102 9.86997",
    fill: "#0C7189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly);
export default __webpack_public_path__ + "static/media/butterfly.923af2ca1415399dcf79ea9fe115e735.svg";
export { ForwardRef as ReactComponent };